import { Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  text: string;
  onPress: () => void;
};

export default function TextButton({ text, onPress }: Props) {
  const tailwind = useTailwind();
  return (
    <Button
      onPress={onPress}
      style={tailwind("my-1 -mx-2")}
      labelStyle={tailwind("text-left w-full px-2")}
    >
      {text}
    </Button>
  );
}
